import { MathUtil } from "./MathUtil";
import {EventDispatcher} from "./Card";
export interface IAudioFile {
    title: string;
    src: string;
}

export class AudioPlayer {

    private static audioFiles: IAudioFile[] = [
        { title: "Apocalypse", src: 'https://playarkham.blob.core.windows.net/audio/Apocalypse.mp3' },
        { title: "Dark Toys", src: 'https://playarkham.blob.core.windows.net/audio/Dark_Toys.mp3' },
        { title: "Fresno Alley", src: 'https://playarkham.blob.core.windows.net/audio/Fresno_Alley.mp3' },
        { title: "Gaia in Fog", src: 'https://playarkham.blob.core.windows.net/audio/Gaia_in_Fog.mp3' },
        { title: "Gansta Choir Descends", src: 'https://playarkham.blob.core.windows.net/audio/Gangsta_Choir_Descends.mp3' },
        { title: "Heartbeat of the Hood", src: 'https://playarkham.blob.core.windows.net/audio/Heartbeat_of_the_Hood.mp3' },
        { title: "King's Men", src: 'https://playarkham.blob.core.windows.net/audio/King_s_Men.mp3' },
        { title: "Leoforos Alexandras", src: 'https://playarkham.blob.core.windows.net/audio/Leoforos_Alexandras.mp3' },
        { title: "Spirit of the Dead", src: 'https://playarkham.blob.core.windows.net/audio/Spirit_of_the_Dead.mp3' },
        { title: "The New Order", src: 'https://playarkham.blob.core.windows.net/audio/The_New_Order.mp3' },
        { title: "Waltz To Death", src: 'https://playarkham.blob.core.windows.net/audio/Waltz_To_Death.mp3' },
        //{ title: "Weirding Way", src: 'https://playarkham.blob.core.windows.net/audio/Weirding_Way.mp3' }
    ];
    private static currentAudio: Howl;
    private static currentIndex: number = 0;
    private static playing: boolean = false;
    private static events = new EventDispatcher<string>();
    private static readonly onChangeEvent="onchange";
    public static volume(vol?: number): number {
        if (vol !== undefined) {
            Howler.volume(vol);
            this.triggerOnChange("volume");
        }
        return Howler.volume();
    }

    public static getCurrentTrack(): IAudioFile {
        return this.audioFiles[this.currentIndex];
    }

    public static isPlaying(): boolean {
        return this.playing;
    }
    public static shuffle(): void {
        const index = MathUtil.random(0, this.audioFiles.length - 1);
        this.start(index);
    }
    static start(index: number) {
        if (this.currentAudio) {
            this.currentAudio.stop();
            this.currentAudio = null;
        }
        this.currentIndex = index;
        this.currentAudio = new Howl({ src: [this.audioFiles[index].src], onend: () => this.skip(1) });
        this.currentAudio.play();
        this.playing = true;
        this.triggerOnChange("play");
    }
    static skip(pos: number) {
        const noOfAudioFiles = this.audioFiles.length;
        if (noOfAudioFiles <= 0) return;

        let index = this.currentIndex;
        index += pos;
        while (index < 0) {
            index += noOfAudioFiles;
        }
        while (index >= noOfAudioFiles) {
            index -= noOfAudioFiles;
        }
        this.start(index);
    }

    static togglePlay() {
        if (!this.currentAudio) {
            this.shuffle();
            return;
        }
        if (this.playing) {
            this.currentAudio.pause();
            this.triggerOnChange("pause");
        } else {
            this.currentAudio.play();
            this.triggerOnChange("play");
        }
        this.playing = !this.playing;
    }
    private static triggerOnChange(arg: string) {
        this.events.trigger(this.onChangeEvent, arg);
    }
    static onChange(handler: (arg:string) => void): void {
        this.events.addEventListener(this.onChangeEvent,handler);
    }

    static removeOnChange(handler: (arg: string) => void): void {
        this.events.removeEventListener(this.onChangeEvent,handler);
    }
}